module.exports = __webpack_public_path__ + "cd3e7c0c1bc2a0c7ac19297ce411390f.svg";